<template>
  <div v-if="$store.getters.retrieveAnon">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-alert
          prominent
          color="teal"
          icon="mdi-map-marker"
          class="ma-0 px-4 py-2"
          outlined
          text
        >
          <v-row align="center" justify="center">
            <v-col cols="12" md="8">
              <span>You're shopping for postcode {{ userPostcode }} </span>
            </v-col>
            <v-col cols="12" md="4" style="text-align: end">
              <v-btn outlined color="teal darken-2" exact v-on="on" class="ml-4"
                >Change Postcode</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </template>

      <v-card>
        <v-card-title>
          <h4>Change postcode</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-form ref="postcodeForm" @submit.prevent="submit()" v-model="valid">
          <v-card-text>
            <v-alert class="text-left" border="left" text type="info">
              Simply enter the postcode you'd like to change to below, this may
              change what products and delivery days are avilable to you.
            </v-alert>

            <v-text-field
              color="primary"
              v-model="postcode"
              prepend-inner-icon="mdi-home"
              outlined
              :rules="[required('PostCode'), isPostCode]"
              label="Postcode"
            />
          </v-card-text>

          <v-card-actions class="dialogActions">
            <v-spacer />
            <v-btn
              outlined
              :disabled="!valid"
              color="blue darken-2"
              class="white--text"
              @click="submit()"
              :loading="loading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmChangeDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Click & Collect Only</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="confirmChangeDialog = false">
            <v-icon>mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-card-title>

        <v-form
          ref="cncOnlyForm"
          @submit.prevent="confirmPostcodeChange()"
          class="mt-2 text-center"
        >
          <v-card-text>
            <v-alert class="text-left" border="left" text type="warning">
              Unfortunately we do not deliver to your postcode
              {{ this.postcode }} however our Click & Collect is available,
              shall we still update your postcode?
            </v-alert>
          </v-card-text>

          <v-card-actions class="dialogActions">
            <v-spacer />
            <v-btn
              outlined
              color="blue darken-2"
              @click="confirmPostcodeChange()"
              :loading="loading"
              class="white--text"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import checkPostCode from "@/util/validation/postcode.js";

export default {
  data() {
    return {
      dialog: false,
      confirmChangeDialog: false,

      loading: false,
      valid: false,

      postcode: this.userPostcode,
      required(fieldName) {
        return (v) => (v && v.length > 0) || `${fieldName} Required`;
      },
      isPostCode: (val) => {
        return checkPostCode(val);
      },
    };
  },

  computed: {
    ...mapGetters(["retrieveUser", "retrieveCustomerAddress"]),
    userEmail() {
      return this.retrieveUser.email_address;
    },
    userName() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.name;
      } else {
        return null;
      }
    },
    userPhone() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.telephone_no;
      } else {
        return null;
      }
    },
    addressLine1() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_1;
      } else {
        return null;
      }
    },
    addressLine2() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_2;
      } else {
        return null;
      }
    },
    addressLine3() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_3;
      } else {
        return null;
      }
    },
    addressLine4() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.address_line_4;
      } else {
        return null;
      }
    },
    userPostcode() {
      if (this.retrieveCustomerAddress) {
        return this.retrieveCustomerAddress.postcode;
      } else {
        return null;
      }
    },
  },

  methods: {
    ...mapActions([
      "checkDeliveryPostcode",
      "getCustomer",
      "setGuestTrolly",
      "setSnackbar",
      "updateAnonUserPostcodeAction",
      "getCustomer",
      "getTrollys",
    ]),

    async submit() {
      if (this.$refs.postcodeForm.validate()) {
        this.loading = true;

        const params = Object.assign(
          { identity: "nws9987" },
          { postcode: this.postcode }
        );

        const postcodeResponse = await this.checkDeliveryPostcode(params);
        console.log(postcodeResponse);

        if (postcodeResponse) {
          if (postcodeResponse.success) {
            if (postcodeResponse.cncOnly) {
              // We only allow CNC so ensure the User knows this by showing the appropriate dialog
              this.confirmChangeDialog = true;
            } else {
              //We're not CNC only so just change straight away
              await this.confirmPostcodeChange();
            }
          } else {
            this.setSnackbar({
              color: "error",
              text:
                "Unfortunately we do not deliver to this postcode at this time.",
            });
          }
        } else {
          //auth-user failed
          this.setSnackbar({
            color: "error",
            text: "Error checking your postcode",
          });
        }
      }

      this.loading = false;
      this.dialog = false;
    },

    async confirmPostcodeChange() {
      this.loading = true;

      const params = Object.assign({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        postcode: this.postcode,
      });

      const postcodeResponse = await this.updateAnonUserPostcodeAction(params);

      console.log("-- Postcode Response");
      console.log(postcodeResponse);

      if (postcodeResponse) {
        if (postcodeResponse.success) {
          await this.getCustomer();
          await this.getTrollys();
        } else {
          this.setSnackbar({
            color: "error",
            text: postcodeResponse.message,
          });
        }
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error updating your postcode",
        });
      }

      this.loading = false;
      this.dialog = false;
      this.confirmChangeDialog = false;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>